module.exports = __webpack_public_path__ + "images/fifth_anniversary/campaign-bottom-scroll_c6b6bdfc9d8b862350be9395e05d6ed5.png";